import moment from "moment";

const useFormatTime = () => {
  const formatTime = (seconds: number): string => {
    const duracao = moment.duration(seconds, 'seconds');

    const dias = Math.floor(duracao.asDays());
    if (dias > 30) {
      const meses = Math.floor(dias / 30);
      return `${meses} mês(es)`;
    }

    if (dias > 7) {
      const semanas = Math.floor(dias / 7);
      return `${semanas} semana(s)`;
    }

    if (dias > 0) {
      return `${dias} dia(s)`;
    }

    const horas = Math.floor(duracao.asHours());
    if (horas > 0) {
      return `${horas} hora(s)`;
    }

    const minutos = Math.floor(duracao.asMinutes());
    if (minutos > 0) {
      return `${minutos} minuto(s)`;
    }

    const segundosRestantes = Math.floor(duracao.asSeconds());
    if (segundosRestantes > 0) {
      return `${segundosRestantes} segundo(s)`;
    }

    return 'Menos de um minuto';
  };

  return { formatTime };
};

export default useFormatTime;
